module.exports = __webpack_public_path__ + "img/icon_right1.png";